import { Component } from '@angular/core';

@Component({
  selector: 'jb-promo-skeleton',
  templateUrl: './promo-skeleton.component.html',
})
export class PromoSkeletonComponent {}
